import { render, staticRenderFns } from "./HelpDescription.vue?vue&type=template&id=650ef8df&"
import script from "./HelpDescription.vue?vue&type=script&lang=js&"
export * from "./HelpDescription.vue?vue&type=script&lang=js&"
import style0 from "./HelpDescription.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports